import React, { useRef, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";

const inp = "h-7 w-full rounded border border-slate-700 bg-slate-800 px-1.5 text-[11px] text-slate-100 placeholder:text-slate-500";
const up = (v) => String(v ?? "").toLocaleUpperCase("tr-TR");
export const PARTY_FIELDS = [["firma", "FİRMA ADI", 2], ["tel", "CEP TEL", 1], ["sabit_tel", "SABİT TEL", 1], ["adres", "AÇIK ADRES", 2], ["ilce", "İLÇE", 1], ["il", "İL", 1], ["vergi_dairesi", "VERGİ DAİRESİ", 1], ["vergi_no", "VERGİ NO", 1]];
const isDeal = (c) => ["hesap", "teklif", "teklif_fiyat"].some((k) => c?.[k] && String(c[k]).trim()) || up(c?.anlasmali) === "EVET";

export const fromCustomer = (role, c) => ({
  [`${role}_firma`]: c.firma || "", [`${role}_tel`]: String(c.gsm || "").split("\n")[0], [`${role}_sabit_tel`]: String(c.s_tel || "").split("\n")[0],
  [`${role}_adres`]: c.adres || "", [`${role}_ilce`]: c.ilce || "", [`${role}_il`]: c.il || "", [`${role}_vergi_dairesi`]: c.vergi_dairesi || "",
  [`${role}_vergi_no`]: c.vergi_no || "", [`${role}_anlasma`]: isDeal(c) ? "ANLAŞMALI" : "ANLAŞMASIZ", [`${role}_kayitli`]: true,
});

export default function CargoParty({ role, title, f, setMany, customers }) {
  const [quick, setQuick] = useState(false);
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const fileRef = useRef(null);
  const K = (k) => `${role}_${k}`;
  const match = (name) => customers.find((x) => up(x.data?.firma) === up(name))?.data;
  const onFirma = (v) => { const c = match(v); setMany(c ? fromCustomer(role, c) : { [K("firma")]: up(v), [K("kayitli")]: false, [K("anlasma")]: "ANLAŞMASIZ" }); };
  const parse = async (file) => {
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("text", txt); if (file) fd.append("file", file);
      const { data: r } = await api.post("/cargo/party-parse", fd);
      const c = match(r.firma);
      setMany(c ? fromCustomer(role, c) : { [K("firma")]: r.firma || "", [K("tel")]: r.gsm || "", [K("sabit_tel")]: r.s_tel || "", [K("adres")]: r.adres || "", [K("ilce")]: r.ilce || "", [K("il")]: r.il || "", [K("vergi_dairesi")]: r.vergi_dairesi || "", [K("vergi_no")]: r.vergi_no || "", [K("kayitli")]: false, [K("anlasma")]: "ANLAŞMASIZ" });
      setQuick(false); setTxt(""); toast.success(c ? "KAYITLI MÜŞTERİ BULUNDU" : "BİLGİLER OKUNDU — KONTROL EDİP KAYDEDİN");
    } catch (e) { toast.error(e.response?.data?.detail || "OKUNAMADI"); }
    setBusy(false);
  };
  const saveCust = async () => {
    try {
      const { data } = await api.post("/cargo/party-save", { data: { firma: f[K("firma")], gsm: f[K("tel")], s_tel: f[K("sabit_tel")], adres: f[K("adres")], il: f[K("il")], ilce: f[K("ilce")], vergi_dairesi: f[K("vergi_dairesi")], vergi_no: f[K("vergi_no")] } });
      data.forEach((r) => toast.success(`${r.firma_adi}: ${r.durum}`));
      setMany({ [K("kayitli")]: true });
    } catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };
  const cur = match(f[K("firma")]);
  const deal = f[K("anlasma")] || (cur && isDeal(cur) ? "ANLAŞMALI" : "ANLAŞMASIZ");
  const registered = !!cur || !!f[K("kayitli")];
  const fold = (v) => up(v).replace(/\s+/g, " ").trim();
  const q = fold(f[K("firma")]);
  const hits = open ? customers.filter((x) => !q || fold(x.data?.firma).includes(q) || String(x.data?.gsm || "").replace(/\D/g, "").includes(q.replace(/\D/g, "") || "-")).slice(0, 40) : [];
  const pick = (c) => { setMany(fromCustomer(role, c.data)); setOpen(false); };
  return (
    <div data-testid={`party-${role}`} className="rounded-lg border border-slate-800 bg-slate-900 p-2">
      <div className="mb-1 flex items-center gap-1.5">
        <span className="text-[11px] font-extrabold tracking-wider text-blue-300">{title}</span>
        {f[K("firma")] && <span data-testid={`party-${role}-deal`} className={`rounded px-1.5 text-[9px] font-bold ${deal === "ANLAŞMALI" ? "bg-emerald-600/25 text-emerald-300" : "bg-amber-600/25 text-amber-300"}`}>{deal || "ANLAŞMASIZ"}</span>}
        {f[K("firma")] && !registered && <button data-testid={`party-${role}-save`} onClick={saveCust} className="rounded bg-blue-600 px-1.5 text-[9px] font-bold text-white">MÜŞTERİ KAYDET</button>}
        <button data-testid={`party-${role}-quick`} onClick={() => setQuick((q) => !q)} title="KAŞE / EKRAN GÖRÜNTÜSÜ / YAZI İLE HIZLI EKLE" className="ml-auto rounded px-1 text-sm hover:bg-slate-800">⚡</button>
      </div>
      {quick && (
        <div className="mb-1.5 space-y-1 rounded border border-amber-700/50 bg-amber-950/20 p-1.5">
          <textarea data-testid={`party-${role}-text`} value={txt} onChange={(e) => setTxt(e.target.value)} placeholder="YAZIYI / KAŞEYİ BURAYA YAPIŞTIRIN" className="h-14 w-full rounded border border-slate-700 bg-slate-800 p-1 text-[11px] text-slate-100" />
          <div className="flex gap-1">
            <button data-testid={`party-${role}-read`} disabled={busy || !txt.trim()} onClick={() => parse(null)} className="rounded bg-amber-600 px-2 py-0.5 text-[10px] font-bold text-white disabled:opacity-40">{busy ? "OKUNUYOR…" : "YAZIDAN OKU"}</button>
            <button data-testid={`party-${role}-image`} disabled={busy} onClick={() => fileRef.current?.click()} className="rounded border border-amber-600 px-2 py-0.5 text-[10px] font-bold text-amber-300 disabled:opacity-40">📷 KAŞE / GÖRSEL</button>
            <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={(e) => e.target.files?.[0] && parse(e.target.files[0])} />
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 gap-1">
        {PARTY_FIELDS.map(([k, l, span]) => k === "firma" ? (
          <div key={k} className="relative col-span-2">
            <input data-testid={`party-${role}-firma`} placeholder={`${l} — YAZIN VEYA LİSTEDEN SEÇİN (${customers.length} MÜŞTERİ)`} value={f[K(k)] || ""} autoComplete="off"
              onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} onChange={(e) => { onFirma(e.target.value); setOpen(true); }}
              className={`${inp} font-bold`} />
            {open && (
              <div data-testid={`party-${role}-list`} className="absolute left-0 right-0 top-7 z-50 max-h-64 overflow-auto rounded border border-slate-600 bg-slate-900 shadow-xl">
                {hits.length === 0 && <div className="px-2 py-1.5 text-[10px] text-amber-300">SİSTEMDE YOK — BİLGİLERİ YAZIP "MÜŞTERİ KAYDET" DEYİN</div>}
                {hits.map((c) => (
                  <button key={c.id} type="button" data-testid={`party-${role}-opt-${c.id}`} onMouseDown={(e) => { e.preventDefault(); pick(c); }}
                    className="flex w-full items-center gap-2 border-b border-slate-800 px-2 py-1 text-left text-[11px] hover:bg-blue-900/40">
                    <span className="flex-1 truncate font-bold text-white">{c.data.firma}</span>
                    <span className="shrink-0 text-[10px] text-slate-400">{[c.data.ilce, c.data.il].filter(Boolean).join(" / ")}</span>
                    {!c.data.vergi_no && <span className="shrink-0 rounded bg-amber-900/50 px-1 text-[9px] text-amber-300">VERGİ NO YOK</span>}
                  </button>
                ))}
              </div>
            )}
          </div>
        ) : (
          <input key={k} data-testid={`party-${role}-${k}`} placeholder={l} value={f[K(k)] || ""}
            onChange={(e) => (k === "firma" ? onFirma(e.target.value) : setMany({ [K(k)]: k.includes("tel") || k === "vergi_no" ? e.target.value : up(e.target.value) }))}
            className={`${inp} ${span === 2 ? "col-span-2" : ""} ${k === "firma" ? "font-bold" : ""}`} />
        ))}
      </div>
    </div>
  );
}
